export default __webpack_public_path__ + "static/media/92FBD047-01B6-455C-8286-E04B42A20C59_1_105_c.bff9e0c9.jpeg";